export const getUpsShippingMethodDescription = (
	code: string,
	language = "en-US",
) => {
	const descriptions: Record<string, Record<string, string>> = {
		"en-US": {
			"01": `Ships within 2 business days`,
			"02": `Ships within 2 business days`,
			"12": `Ships within 2 business days`,
			"03": `Ships within 2 business days`,
			"11": `Ships within 2 business days`,
		},
		"en-CA": {
			"01": `Ships within 2 business days`,
			"02": `Ships within 2 business days`,
			"12": `Ships within 2 business days`,
			"03": `Ships within 2 business days`,
			"11": `Ships within 2 business days`,
		},
		"fr-CA": {
			"01": `Expédition dans les 2 jours ouvrables`,
			"02": `Expédition dans les 2 jours ouvrables`,
			"12": `Expédition dans les 2 jours ouvrables`,
			"03": `Expédition dans les 2 jours ouvrables`,
			"11": `Expédition dans les 2 jours ouvrables`,
		},
	};

	return descriptions[language]?.[code] ?? "";
};
